import { useSelector } from "react-redux"
import { hasPermission } from "helpers/permissions"
import { isPermissionedResource } from "helpers/permissions/resource-types"
import { getRole } from "helpers/permissions/roles"
import useResource from "./resources"

export function useResourcePermission(resourceType, resourceId) {
  return useResource({
    resource: `resourcePermission-${resourceId}`,
    url: () => isPermissionedResource(resourceType) ? ({
      id: `resourcePermission-${resourceId}`,
      query: `query ($resourceType: ResourceType!, $resourceId: IdOrShortIdOrAlias!) {
        resource(type: $resourceType, id: $resourceId) {
          id
          permissionLevel
        }
      }`,
      variables: { resourceType, resourceId },
    }) : null,
  }, ["resource", "permissionLevel"])
}

// [TODO] make useHasResourcePermission more generic than resourceMetadata
//  e.g. pass in a resourceId, resourceType, and permissionLevel,
//  then retrieve the resourceMetadata from the resourceId and resourceType,
//  then check if the resourceMetadata has the permissionLevel,
//  then return the permission.
export function useHasResourcePermission(resourceMetadata, permissionLevel) {
  const role = useSelector(getRole)

  if (!resourceMetadata) {
    return false
  }

  const isPermitted = hasPermission(resourceMetadata.permissionLevel, permissionLevel)
  return role === "admin" || isPermitted
}
